'use strict';

bbw.directive.bbwTouchHref = ['$parse', '$timeout', function($parse, $timeout) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var destroyed;
            scope.$on('$destroy', function() {
                destroyed = true;
            });
            ['click', 'touchstart', 'touchend'].forEach(function(name) {
                element.bind(name, function($event) {
                    $event.stopPropagation();
                    if (name === 'touchend' && attrs.bbwTouchHref) {
                        var fn = $parse(attrs.bbwTouchHref, null, true);
                        var callback = function() {
                            if (destroyed) {
                                return;
                            }
                            try {
                                fn(scope);
                            } catch (e) {
                                // pass
                            }
                        };
                        $timeout(callback, 600);
                    }
                });
            });
        }
    };
}];
